import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export function IspNode2(props) {
    return <NodeWithMultipleHandles {...props} nodeType="isp2" />;
}
